export const endpoint = "/api/user-settings";

export const updateUserSettings = (type, payload) =>
  axios.post(`${endpoint}/update`, { type, value: payload });

export const updateExplorerSettings = (payload) => {
  const type = "explorer_view";
  return updateUserSettings(type, payload);
};

export const updateAvatarSettings = (payload) => {
  const type = "avatar";
  return updateUserSettings(type, payload);
};
